type PushStateArgs = Parameters<typeof window.history.pushState>
type ReplaceStateArgs = Parameters<typeof window.history.replaceState>

interface RegisterParams {
  onChange: (url: string | URL | null | undefined) => void
}
export function register(params: RegisterParams) {
  const { onChange } = params

  window.history.pushState = new Proxy(window.history.pushState, {
    apply: (target, thisArg, argArray: PushStateArgs) => {
      target.apply(thisArg, argArray)
      onChange(argArray[2])
    },
  })

  window.history.replaceState = new Proxy(window.history.replaceState, {
    apply: (target, thisArg, argArray: ReplaceStateArgs) => {
      target.apply(thisArg, argArray)
      onChange(argArray[2])
    },
  })
}
